import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { Capacitor } from '@capacitor/core';

class HapticsService {
  public enabled: boolean = true;

  public async vibrateLight(): Promise<void> {
    if (!this.enabled) return;
    try {
      if (Capacitor.isNativePlatform()) {
        await Haptics.impact({ style: ImpactStyle.Light });
      } else if ('vibrate' in navigator) {
        navigator.vibrate(10);
      }
    } catch {
      // Ignore haptics errors on unsupported browsers
    }
  }

  public async vibrateMedium(): Promise<void> {
    if (!this.enabled) return;
    try {
      if (Capacitor.isNativePlatform()) {
        await Haptics.impact({ style: ImpactStyle.Medium });
      } else if ('vibrate' in navigator) {
        navigator.vibrate(30);
      }
    } catch {
      // Ignore
    }
  }

  public async vibrateHeavy(): Promise<void> {
    if (!this.enabled) return;
    try {
      if (Capacitor.isNativePlatform()) {
        await Haptics.notification({ type: NotificationType.Error });
      } else if ('vibrate' in navigator) {
        navigator.vibrate([100, 50, 100]);
      }
    } catch {
      // Ignore
    }
  }
}

export const hapticsService = new HapticsService();
